export default {
  supportedLngs: ['en', 'es', 'fr', 'it', 'nl', 'de', 'pt'],
  fallbackLng: 'en',
  ns: ['ecommerce', 'countries'],
  defaultNS: 'ecommerce',
  react: { useSuspense: false },
};
